import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'

const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      customSoftware: 'Özel Yazılım',
      blog: 'Blog',
      projects: 'Projeler',
      about: 'Hakkımızda',
      contact: 'İletişim',
      faq: 'SSS',
      quote: 'Teklif Al',
    },
    home: {
      meta: {
        title: 'Efes Tech - Mobil Uygulama ve Özel Yazılım Çözümleri',
        description:
          'Efes Tech (Efes Yazılım) olarak iOS, Android ve web uygulamaları geliştiriyoruz. İşletmenize özel yazılım, yapay zeka entegrasyonu; OTS, Elestir.net, Stuby gibi profesyonel çözümler sunuyoruz.',
        keywords:
          'efes yazılım, özel yazılım, ios uygulama geliştirme, android uygulama geliştirme, web yazılım, yapay zeka entegrasyonu, yazılım outsourcing, elestir.net, ots sipariş takip, stuby, dünya evim, ilaç saati',
      },
      hero: {
        highlight: 'İşletmeniz İçin',
        title: 'Dijital Dönüşüm Çözümleri',
        subtitle:
          'Modern teknolojiler ile işletmenizi geleceğe taşıyoruz. Özel yazılım çözümleri, mobil uygulamalar ve web projeleri geliştiriyoruz.',
        cta: 'Projeyi Hayata Geçirelim',
        ctaSecondary: 'Teklif Al',
      },
      stats: [
        { number: '50+', label: 'Başarılı Proje' },
        { number: '5+', label: 'Yıllık Deneyim' },
        { number: '100%', label: 'Müşteri Memnuniyeti' },
      ],
      techBadges: ['iOS', 'Android', 'Web', 'Özel Yazılım', 'UI/UX'],
      sections: {
        servicesTitle: 'Hizmetlerimiz',
        servicesSubtitle: 'İşletmeniz için en iyi çözümleri sunuyoruz',
        projectsTitle: 'Projelerimiz',
        projectsSubtitle: 'Başarıyla tamamladığımız projelerimizden örnekler',
        blogTitle: 'Blog',
        blogSubtitle: 'Teknoloji dünyasından güncel yazılar',
      },
      labels: {
        learnMore: 'Detaylı Bilgi',
        readMore: 'Devamını Oku',
      },
      services: [
        {
          title: 'iOS Uygulama Geliştirme',
          description:
            "Swift ve SwiftUI kullanarak native iOS uygulamaları geliştiriyoruz. App Store'da yayınlama süreçlerinde de yanınızdayız.",
          icon: 'pi pi-apple',
        },
        {
          title: 'Android Uygulama Geliştirme',
          description:
            "Kotlin ve Jetpack Compose ile modern Android uygulamaları geliştiriyoruz. Google Play Store'da yayınlama desteği sunuyoruz.",
          icon: 'pi pi-android',
        },
        {
          title: 'Cross-Platform Geliştirme',
          description:
            'React Native ve Flutter ile tek kod tabanından hem iOS hem Android için uygulama geliştiriyoruz. Hızlı ve maliyet etkin çözümler.',
          icon: 'pi pi-mobile',
        },
        {
          title: 'Web Uygulama Geliştirme',
          description:
            'Modern web teknolojileri (Vue.js, React, Angular) ile responsive ve kullanıcı dostu web uygulamaları geliştiriyoruz.',
          icon: 'pi pi-globe',
        },
        {
          title: 'Özel Yazılım Geliştirme',
          description:
            'İşletmenizin ihtiyaçlarına özel, ölçeklenebilir ve güvenli yazılım çözümleri geliştiriyoruz. Backend sistemleri ve API entegrasyonları.',
          icon: 'pi pi-code',
        },
        {
          title: 'UI/UX Tasarım',
          description:
            'Kullanıcı deneyimini ön planda tutan, modern ve etkileyici arayüz tasarımları oluşturuyoruz. Prototip ve wireframe hizmetleri.',
          icon: 'pi pi-palette',
        },
      ],
    },
    projects: {
      meta: {
        title: 'Projelerimiz - Efes Tech',
        description:
          'Efes Tech olarak geliştirdiğimiz mobil uygulamalar ve web projeleri.',
      },
      title: 'Projelerimiz',
      subtitle: 'Modern teknolojiler ile geliştirdiğimiz projelerimiz',
      websiteLabel: 'Web Sitesi',
    },
    projectDetail: {
      meta: {
        titleSuffix: ' | Efes Tech',
        descriptionFallback: 'Projelerimiz hakkında detaylı bilgi edinin.',
      },
      technologiesTitle: 'Kullanılan Teknolojiler',
      websiteLabel: 'Web Sitesi',
      appStoreAlt: "App Store'dan İndir",
      playStoreAlt: "Google Play'den İndir",
      privacyLabel: 'Gizlilik Politikası',
      termsLabel: 'Kullanım Şartları',
      notFoundTitle: 'Proje Bulunamadı',
      notFoundDescription: 'Aradığınız proje bulunamadı veya kaldırılmış olabilir.',
      backButton: 'Projelere Dön',
    },
    blog: {
      meta: {
        title: 'Blog | Efes Tech - Özel Yazılım, Şirket İçi Çözümler ve Teknoloji',
        description:
          'Özel şirket yazılımları, şirket içi çözümler, süreç otomasyonu, B2B portallar, mobil uygulama ve modern yazılım teknolojileri hakkında güncel rehberler.',
        keywords: 'özel şirket yazılımı, şirket içi yazılımlar, b2b portal, kurumsal intranet, süreç otomasyonu, mobil uygulama, yazılım ajansı, blog',
      },
      heroTitle: 'Blog & Kurumsal Rehberler',
      heroSubtitle: 'Özel yazılım mimarisi, şirket içi operasyonel çözümler ve teknoloji dünyasından uzman içerikler',
      readMore: 'Devamını Oku',
      searchPlaceholder: 'Yazılarda veya etiketlerde arayın...',
      allCategory: 'Tümü',
      resultsCount: 'yazı listeleniyor',
      noResultsTitle: 'Eşleşen Yazı Bulunamadı',
      noResultsDesc: 'Arama kriterlerinize veya seçilen kategoriye uygun blog yazısı bulunamadı.',
      clearFilters: 'Filtreleri Temizle',
    },
    blogDetail: {
      titleSuffix: ' | Efes Tech Blog',
      backButton: 'Blog Sayfasına Dön',
      notFoundTitle: 'Yazı Bulunamadı',
      notFoundDescription: 'Aradığınız blog yazısı mevcut değil.',
      backLinkLabel: 'Blog Sayfasına Dön',
      authorLabel: 'Efes Tech Mühendislik',
      shareLabel: 'Paylaş',
      copyLinkLabel: 'Bağlantıyı Kopyala',
      copiedToast: 'Yazı bağlantısı panoya kopyalandı!',
      relatedTitle: 'İlgili Diğer Yazılar',
      cta: {
        badge: 'Kurumsal & Özel Çözümler',
        title: 'Şirketiniz İçin Özel Yazılım veya İç Çözüm Mü Geliştirmek İstiyorsunuz?',
        description:
          'İş akışlarınıza %100 uyum sağlayan kurumsal iç yazılımlar, B2B portallar ve mobil uygulamalar için mimari danışmanlık ve anlık maliyet hesabı yapın.',
        calcButton: 'Maliyeti Hesaplayın',
        quoteButton: 'Hemen Teklif Alın',
      },
    },
    about: {
      meta: {
        title: 'Hakkımızda - Efes Tech',
        description:
          'Efes Tech olarak deneyimli ekibimizle modern yazılım çözümleri sunuyoruz.',
      },
      heroTitle: 'Hakkımızda',
      heroSubtitle: 'Yazılım geliştirme konusunda uzman ekibimizle yanınızdayız',
      sections: {
        aboutUsTitle: 'Biz Kimiz?',
        aboutUsContent:
          'Efes Tech olarak, yazılım geliştirme konusunda uzman ekibimizle müşterilerimize en iyi hizmeti sunuyoruz. Deneyimli yazılım geliştiricilerimiz ve tasarımcılarımızla, modern ve kullanıcı dostu yazılım çözümleri geliştiriyoruz.',
        missionTitle: 'Misyonumuz',
        missionContent:
          'Müşterilerimizin ihtiyaçlarını en iyi şekilde anlayarak, onlara özel yazılım çözümleri üretmek ve teknolojik yenilikleri yakından takip ederek en güncel çözümleri sunmak.',
        visionTitle: 'Vizyonumuz',
        visionContent:
          'Yazılım geliştirme alanında öncü ve yenilikçi çözümler sunarak, müşterilerimizin dijital dönüşüm yolculuklarında güvenilir bir teknoloji ortağı olmak.',
        valuesTitle: 'Değerlerimiz',
        valuesList: [
          'Kalite ve Güvenilirlik',
          'Müşteri Odaklılık',
          'Yenilikçilik',
          'Şeffaflık',
          'Sürekli Gelişim',
        ],
        contactTitle: 'Bizimle İletişime Geçin',
        contactSubtitle:
          'Projeleriniz için bizimle iletişime geçebilir, detaylı bilgi alabilirsiniz.',
        contactButton: 'İletişime Geç',
      },
    },
    contact: {
      meta: {
        title: 'İletişim - Efes Tech',
        description: 'Efes Tech ile iletişime geçin, projelerinizi konuşalım.',
      },
      title: 'İletişim',
      subtitle: 'Bizimle iletişime geçin, projenizi konuşalım',
      infoCard: {
        title: 'İletişim Bilgileri',
        addressLabel: 'Adres',
        phoneLabel: 'Telefon',
        emailLabel: 'E-posta',
        websiteLabel: 'Web Sitesi',
        socialLinks: {
          linkedin: 'LinkedIn',
          instagram: 'Instagram',
          twitter: 'Twitter',
        },
      },
      form: {
        title: 'İletişim Formu',
        nameLabel: 'Adınız Soyadınız',
        emailLabel: 'E-posta Adresiniz',
        subjectLabel: 'Konu',
        messageLabel: 'Mesajınız',
        submitLabel: 'Gönder',
      },
      toasts: {
        validation: {
          summary: 'Hata',
          detail: 'Lütfen tüm alanları doldurun.',
        },
        success: {
          summary: 'Başarılı',
          detail: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.',
        },
        error: {
          summary: 'Hata',
          detail: 'Mesajınız gönderilemedi. Lütfen daha sonra tekrar deneyin.',
        },
      },
    },
    footer: {
      companyName: 'Efes Tech',
      description: 'Yazılım geliştirme konusunda uzman ekibimizle yanınızdayız.',
      quickLinksTitle: 'Hızlı Bağlantılar',
      quickLinks: [
        { to: '/', label: 'Ana Sayfa' },
        { to: '/ozel-yazilim-gelistirme', label: 'Özel Yazılım' },
        { to: '/projects', label: 'Projeler' },
        { to: '/references', label: 'Referanslar' },
        { to: '/about', label: 'Hakkımızda' },
        { to: '/blog', label: 'Blog' },
        { to: '/faq', label: 'SSS' },
        { to: '/contact', label: 'İletişim' },
        { to: '/delete-account', label: 'Hesap Silme' },
        { to: '/privacy-policy', label: 'Gizlilik Politikası' },
      ],
      contactTitle: 'İletişim',
      contactItems: {
        email: 'admin@efestech.com',
        phone: '+90 536 788 44 50',
        address:
          'EVLİYA ÇELEBİ MAH. SADİ KONURALP CAD. IKSV VAKFI NO: 5 İÇ KAPI NO: 2 BEYOĞLU/İSTANBUL',
      },
      bottomText: '© {year} Efes Tech. Tüm hakları saklıdır.',
    },
    faq: {
      meta: {
        title: 'Sıkça Sorulan Sorular - Efes Tech',
        description:
          'Efes Tech hakkında sıkça sorulan sorular ve cevapları. iOS, Android ve web uygulama geliştirme hizmetlerimiz hakkında bilgi alın.',
      },
      heroTitle: 'Sıkça Sorulan Sorular',
      heroSubtitle: 'Merak ettikleriniz hakkında bilgi alın',
      questions: [
        {
          question: 'Hangi platformlar için uygulama geliştiriyorsunuz?',
          answer:
            'iOS, Android ve Web platformları için uygulama geliştirme hizmeti sunuyoruz. Native iOS (Swift/SwiftUI), Native Android (Kotlin/Jetpack Compose) ve modern web teknolojileri (Vue.js, React, TypeScript) kullanıyoruz.',
        },
        {
          question: 'Proje süresi ne kadar?',
          answer:
            'Proje süresi, projenin kapsamına ve karmaşıklığına göre değişiklik gösterir. Genellikle basit bir mobil uygulama veya MVP (Minimum Viable Product) için 4-6 hafta, daha geniş kapsamlı ve karmaşık projeler için ise 3-6 ay arasında teslimat gerçekleştiriyoruz.',
        },
        {
          question: 'Fiyatlandırma nasıl yapılıyor?',
          answer:
            'Projelerimiz, kapsam ve gereksinimlere göre özel fiyatlandırılır. Detaylı bir teklif almak için iletişim formumuzu doldurabilir veya doğrudan bizimle iletişime geçebilirsiniz.',
        },
        {
          question: 'Uygulama geliştirme sonrası destek sağlıyor musunuz?',
          answer:
            'Evet, uygulama geliştirme sonrası bakım, güncelleme ve teknik destek hizmetleri sunuyoruz. Uygulamanızın güncel kalması ve sorunsuz çalışması için sürekli destek sağlıyoruz.',
        },
        {
          question: 'Hangi teknolojileri kullanıyorsunuz?',
          answer:
            'iOS için Swift ve SwiftUI, Android için Kotlin ve Jetpack Compose, Web için Vue.js, React ve TypeScript kullanıyoruz. Ayrıca Flutter ile cross-platform geliştirme de yapıyoruz.',
        },
        {
          question: 'Portföyünüzde hangi projeler var?',
          answer:
            'Portföyümüzde OTS (Sipariş Takip Sistemi), Eleştir, Stuby, İlaç Saati, Dünya Evim, Battleship.pro ve CSV Formatter & Mapper gibi başarılı projeler bulunmaktadır. Projelerimiz sayfasından detaylı bilgi alabilirsiniz.',
        },
      ],
    },
    ilacSaatiPrivacy: {
      meta: {
        title: 'İlaç Saati - Gizlilik Politikası',
        description:
          'İlaç Saati uygulamasının gizlilik politikası; veri toplama, kullanım, saklama ve kullanıcı hakları hakkında bilgiler.',
      },
      header: {
        eyebrow: 'Gizlilik Politikası',
        title: 'İlaç Saati',
        updated: 'Son güncelleme: 15 Kasım 2025',
      },
      sections: [
        {
          title: '1. Genel Bilgi',
          paragraphs: [
            'İlaç Saati (“uygulama”) kullanıcılarının ilaç hatırlatmalarını yönetmesine yardımcı olmak için tasarlanmıştır. Uygulamayı kullanarak, gizlilik politikamızda açıklanan veri işleme faaliyetlerini kabul etmiş olursunuz.',
          ],
        },
        {
          title: '2. Toplanan Veriler',
          paragraphs: [
            'Bu veriler yalnızca cihazınızda saklanır; bulut veya üçüncü taraf sunucularına gönderilmez.',
          ],
          listItems: [
            '<strong>Kişisel Bilgiler:</strong> Kullanıcı profilleri, kişi adları, ilaç isimleri ve açıklamaları gibi uygulamada manuel girilen bilgiler.',
            '<strong>Cihaz Verileri:</strong> Bildirim izinleri, uygulama sürümü, cihaz dili.',
            '<strong>Günlük Kayıtları:</strong> İlaç alım durumları, seçilen tarih aralıkları ve hatırlatma saatleri.',
          ],
        },
        {
          title: '3. Verilerin Kullanım Amaçları',
          listItems: [
            'İlaç hatırlatmalarını planlama ve bildirimi sağlamak',
            'Aynı cihazda birden çok kişi için kayıtları yönetmek',
            'Bildirim izinleri ve hata ayıklama süreçleri',
          ],
        },
        {
          title: '4. Veri Saklama',
          paragraphs: [
            'Tüm veriler cihazınızdaki yerel depolamada tutulur; uygulamayı silmeniz halinde veriler de silinir.',
          ],
        },
        {
          title: '5. Üçüncü Taraf Paylaşımı',
          paragraphs: [
            'Verileriniz hiçbir koşulda üçüncü taraflarla paylaşılmaz, satılmaz veya reklam amaçlı kullanılmaz.',
          ],
        },
        {
          title: '6. Kullanıcı Hakları',
          listItems: [
            'Verilerin tamamını uygulama içinden silebilirsiniz.',
            'Bildirim izinlerini cihaz ayarlarından yönetebilirsiniz.',
            'Sorularınız için: <a href="mailto:admin@efestech.com">admin@efestech.com</a>',
          ],
        },
        {
          title: '7. Güvenlik',
          paragraphs: [
            'Veriler yalnızca yerel cihaz depolamasında tutulduğundan, cihazınızı korumak sizin sorumluluğunuzdadır. Güncel işletim sistemi ve güçlü ekran kilidi kullanmanız önerilir.',
          ],
        },
        {
          title: '8. Politikadaki Değişiklikler',
          paragraphs: [
            'Gizlilik politikası gerektiğinde güncellenebilir. Önemli değişiklikler uygulama içi bildirim veya web sitesi üzerinden duyurulur.',
          ],
        },
      ] satisfies PolicySection[],
    },
    ilacSaatiTerms: {
      meta: {
        title: 'İlaç Saati - Kullanım Şartları',
        description:
          'İlaç Saati uygulaması kullanım şartları; hizmet tanımı, kullanım kuralları, sorumluluk reddi ve iletişim bilgileri.',
      },
      header: {
        eyebrow: 'Kullanım Şartları',
        title: 'İlaç Saati',
        updated: 'Son güncelleme: 15 Kasım 2025',
      },
      sections: [
        {
          title: '1. Şartların Kabulü',
          paragraphs: [
            'İlaç Saati uygulamasını kullanarak işbu kullanım şartlarını kabul etmiş sayılırsınız. Şartları kabul etmiyorsanız uygulamayı kullanmayınız.',
          ],
        },
        {
          title: '2. Hizmet Tanımı',
          paragraphs: [
            'Uygulama, kişilerin ilaç saatlerini planlamasına yardımcı olur; tıbbi tavsiye sağlamaz, tıbbi cihaz değildir. İlaç dozlarını mutlaka hekiminiz/eczacınızla doğrulayınız.',
          ],
        },
        {
          title: '3. Kullanım Kuralları',
          listItems: [
            'Uygulama yalnızca kişisel amaçlarla kullanılmalıdır.',
            'Uygulamamızı kötüye kullanamaz, tersine mühendislik yapamaz veya izinsiz paylaşamazsınız.',
            'Üçüncü kişilerin haklarını ihlal edecek içerikler girmemelisiniz.',
          ],
        },
        {
          title: '4. Bildirimler',
          paragraphs: [
            'Doğru hatırlatma için cihazınızda bildirim ve alarm izinlerinin açık olması gerekir.',
            'Bildirim gelmemesi cihaz ayarları veya işletim sistemi kısıtlamalarından kaynaklanabilir; sorumluluk kullanıcıya aittir.',
          ],
        },
        {
          title: '5. Sorumluluk Reddi',
          paragraphs: [
            'Uygulama, ilaç alımlarının doğruluğunu garanti etmez; hatalı veya geciken bildirimler sonucu oluşabilecek zararlardan geliştirici sorumlu tutulamaz.',
            'Tıbbi acil durumlarda uygulamaya güvenmeyiniz; ilgili sağlık kuruluşlarına başvurunuz.',
          ],
        },
        {
          title: '6. Ücretlendirme',
          paragraphs: [
            'Uygulama şu an için ücretsizdir. Gelecekte ücretli özellikler eklenmesi halinde kullanıcılar bilgilendirilecektir.',
          ],
        },
        {
          title: '7. Fesih',
          paragraphs: [
            'Kullanım şartlarını ihlal eden kullanıcıların uygulamaya erişimi engellenebilir. Kullanıcı dilediği zaman uygulamayı kaldırarak kullanımı sonlandırabilir.',
          ],
        },
        {
          title: '8. Değişiklikler',
          paragraphs: [
            'Şartlar zaman zaman güncellenebilir. Değişiklikler web sitesi veya uygulama içi duyurularla iletilir. Güncellemeleri takip etmek kullanıcı sorumluluğundadır.',
          ],
        },
        {
          title: '9. İletişim',
          paragraphs: [
            'Her türlü soru, görüş veya şikayet için: <a href="mailto:admin@efestech.com">admin@efestech.com</a>',
          ],
        },
      ] satisfies PolicySection[],
    },
    quote: {
      meta: {
        title: 'Teklif Al - Efes Tech',
        description: 'Projeniz için Efes Tech\'ten detaylı teklif alın.',
      },
      title: 'Projeniz İçin Teklif Alın',
      subtitle: 'Hayalinizdeki projeyi hayata geçirmek için ilk adımı atın',
      form: {
        nameLabel: 'Adınız Soyadınız *',
        emailLabel: 'E-posta Adresiniz *',
        phoneLabel: 'Telefon Numaranız',
        projectTypeLabel: 'Proje Türü *',
        budgetLabel: 'Tahmini Bütçe (Opsiyonel)',
        detailsLabel: 'Proje Detayları (Opsiyonel)',
        detailsPlaceholder: 'Projenizden kısaca bahsedin...',
        submitLabel: 'Teklif İste',
        companyLabel: 'Firma / Kurum Adı (Opsiyonel)',
        timelineLabel: 'Planlanan Süre (Opsiyonel)',
        budgetPlaceholder: 'Örn: 50.000₺ veya 5.000$',
        projectStatusLabel: 'Proje Durumu (Opsiyonel)',
        projectTypes: {
          mobile: 'Mobil Uygulama',
          web: 'Web Uygulama',
          custom: 'Özel Yazılım',
          uiux: 'UI/UX Tasarım',
          other: 'Diğer',
        },
        timelines: {
          t1: '1-3 Ay',
          t2: '3-6 Ay',
          t3: '6 Aydan Fazla',
          t4: 'Zaman Kısıtlaması Yok',
        },
        projectStatuses: {
          idea: 'Sadece Fikrim Var',
          design: 'Tasarım Aşamasında',
          development: 'Geliştirme Aşamasında',
          revamp: 'Mevcut Projeyi Yenilemek',
        },
      },
      toasts: {
        validation: {
          summary: 'Hata',
          detail: 'Lütfen zorunlu alanları doldurun.',
        },
        success: {
          summary: 'Başarılı',
          detail: 'Teklif talebiniz alınmıştır. En kısa sürede size dönüş yapacağız.',
        },
        error: {
          summary: 'Hata',
          detail: 'Teklif talebiniz gönderilemedi. Lütfen daha sonra tekrar deneyin.',
        },
      },
    },
    customSoftware: {
      meta: {
        title: 'Özel Yazılım Geliştirme Hizmetleri | Kurumsal Çözümler - Efes Tech',
        description:
          'İşletmenize özel web ve mobil yazılım çözümleri. Sıfır lisans bağımlılığı, ölçeklenebilir mimari, API entegrasyonları ve modern teknolojilerle özel yazılım geliştirme.',
        keywords:
          'özel yazılım geliştirme, özel yazılım şirketi, kurumsal yazılım, özel web yazılımı, özel mobil uygulama, b2b yazılım çözümleri, crm erp yazılımı istanbul, yazılım ajansı',
      },
      hero: {
        badge: 'Kurumsal & Ölçeklenebilir Çözümler',
        title: 'İşletmenizin İhtiyaçlarına Özel',
        highlight: 'Yazılım Geliştirme Çözümleri',
        subtitle:
          'Hazır kalıplara sığmayan iş modelleriniz için baştan uca tasarlanmış, yüksek performanslı, güvenli ve lisans bağımsız özel yazılımlar geliştiriyoruz.',
        ctaPrimary: 'Maliyeti Hesaplayın',
        ctaSecondary: 'Hemen Teklif Alın',
        stats: [
          { number: '50+', label: 'Tamamlanan Proje' },
          { number: '%100', label: 'Kod & Mülkiyet Devri' },
          { number: '5+', label: 'Yıllık Mühendislik Deneyimi' },
          { number: '7/24', label: 'Teknik Destek & Bakım' },
        ],
      },
      whyCustom: {
        badge: 'Neden Özel Yazılım?',
        title: 'Hazır Paket Yazılımlar mı, İşletmenize Özel Yazılım mı?',
        subtitle:
          'Standart paket programların sınırlarına takılmayın. Şirketinizin büyüme hızına ve tam iş akışına uyum sağlayan özel çözümlerle rekabette öne geçin.',
        comparisonHeaders: {
          feature: 'Kriter / Özellik',
          custom: 'Efes Tech Özel Yazılım',
          package: 'Hazır Paket Yazılım (SaaS)',
        },
        comparisonRows: [
          {
            feature: 'İş Süreçlerine Uyum',
            custom: '%100 Şirketinize & İş Akışınıza Özel Tasarım',
            package: 'Şirketinizi programın kalıplarına uydurma zorunluluğu',
            advantage: true,
          },
          {
            feature: 'Lisans ve Kullanıcı Maliyeti',
            custom: 'Sıfır kullanıcı lisans ücreti (Sonsuz kullanıcı)',
            package: 'Kullanıcı ve modül başına sürekli artan aylık/yıllık faturalar',
            advantage: true,
          },
          {
            feature: 'Mülkiyet & Kaynak Kodları',
            custom: 'Tüm fikri mülkiyet ve kaynak kodlar tamamen size aittir',
            package: 'Yazılım sağlayıcısına bağımlılık, kod erişimi yok',
            advantage: true,
          },
          {
            feature: 'Ölçeklenebilirlik & Esneklik',
            custom: 'İstediğiniz zaman yeni modül ve özellik eklenebilir',
            package: 'Yalnızca sağlayıcının sunduğu kısıtlı özellikler',
            advantage: true,
          },
          {
            feature: 'Entegrasyon & API Gücü',
            custom: 'Mevcut muhasebe, ERP, CRM ve donanımlarla tam entegre',
            package: 'Sınırlı veya ekstra ücretli entegrasyon olanakları',
            advantage: true,
          },
          {
            feature: 'Veri Güvenliği & KVKK',
            custom: 'Kendi sunucunuzda/özel bulutunuzda tam veri kontrolü',
            package: 'Ortak paylaşımlı yabancı sunucularda veri saklama',
            advantage: true,
          },
        ],
      },
      services: {
        badge: 'Hizmet Kapsamımız',
        title: 'Özel Yazılım Geliştirme Alanlarımız',
        subtitle: 'Fikirden canlıya, tüm platformlarda modern ve uçtan uca yazılım mühendisliği.',
        items: [
          {
            icon: 'pi pi-globe',
            title: 'Özel Web Uygulamaları & Portallar',
            description:
              'Müşteri panelleri, B2B sipariş platformları, operasyon yönetim portalları ve ölçeklenebilir SaaS web uygulamaları geliştiriyoruz.',
            tags: ['Vue.js', 'React', 'TypeScript', 'Node.js'],
          },
          {
            icon: 'pi pi-mobile',
            title: 'Özel Mobil Uygulama Geliştirme',
            description:
              'iOS ve Android için native (Swift, Kotlin) veya cross-platform (Flutter) yüksek performanslı kurumsal mobil uygulamalar.',
            tags: ['iOS (Swift)', 'Android (Kotlin)', 'Flutter', 'Offline-First'],
          },
          {
            icon: 'pi pi-database',
            title: 'Özel ERP, CRM & Süreç Otomasyonu',
            description:
              'Şirketinizin departmanlarını, stok, cari, lojistik ve teklif süreçlerini tek çatı altında toplayan merkezi yönetim sistemleri.',
            tags: ['Süreç Otomasyonu', 'Cari & Stok', 'Lojistik', 'Raporlama'],
          },
          {
            icon: 'pi pi-share-alt',
            title: 'API Geliştirme & Sistem Entegrasyonları',
            description:
              'Pazaryerleri (Trendyol, Hepsiburada, Amazon), e-fatura, banka sanal POS ve kargo sistemleri ile çift yönlü gerçek zamanlı entegrasyonlar.',
            tags: ['REST / GraphQL', 'Sanal POS', 'E-Fatura', 'Pazaryeri API'],
          },
          {
            icon: 'pi pi-bolt',
            title: 'Yapay Zeka (AI) & Akıllı Asistan Entegrasyonları',
            description:
              'İşletmenizin verilerini işleyen LLM/Gemini akıllı asistanlar, otomatik belge işleme ve öngörülü analitik algoritmaları.',
            tags: ['OpenAI / Gemini', 'LLM Entegrasyonu', 'Otomasyon', 'Veri Analizi'],
          },
          {
            icon: 'pi pi-shield',
            title: 'Yüksek Güvenlikli Bulut Mimarileri & Bakım',
            description:
              'AWS, Google Cloud ve özel sunucularda yüksek erişilebilirlikli (High Availability), yedekli ve KVKK uyumlu altyapı yönetimi.',
            tags: ['Docker', 'Cloud CI/CD', '7/24 İzleme', 'SLA Bakım'],
          },
        ],
      },
      process: {
        badge: 'Geliştirme Metodolojimiz',
        title: '5 Adımda Özel Yazılım Geliştirme Sürecimiz',
        subtitle: 'Şeffaf iletişim, çevik (Agile) sprintler ve düzenli demo sunumları ile risksiz teslimat.',
        steps: [
          {
            step: '01',
            title: 'Keşif & İhtiyaç Analizi',
            description:
              'İş süreçlerinizi, hedeflerinizi ve teknik gereksinimlerinizi detaylı olarak dinliyor; kapsam ve yol haritasını (Roadmap) çıkarıyoruz.',
          },
          {
            step: '02',
            title: 'Mimari Tasarım & UI/UX Prototipleme',
            description:
              'Kullanıcı dostu modern ekran tasarımlarını (Figma) ve ölçeklenebilir veritabanı/sistem mimarisini onayınıza sunuyoruz.',
          },
          {
            step: '03',
            title: 'Çevik (Agile) Geliştirme & Sprintler',
            description:
              '2 haftalık sprintler halinde kodlama yapıyor; her sprint sonunda çalışan özellikleri canlı test ortamında incelemenizi sağlıyoruz.',
          },
          {
            step: '04',
            title: 'Test, Güvenlik & Kalite Güvencesi (QA)',
            description:
              'Fonksiyonel testler, yük ve performans testleri, güvenlik taramaları ve kullanıcı kabul testleri (UAT) ile hatasızlığı garanti ediyoruz.',
          },
          {
            step: '05',
            title: 'Canlıya Alma, Kod Devri & 7/24 Destek',
            description:
              'Sistemi canlı sunuculara kuruyor, kaynak kodları ve dökümantasyonu teslim ediyor; SLA kapsamında teknik destek sağlıyoruz.',
          },
        ],
      },
      calculator: {
        badge: 'İnteraktif Araç',
        title: 'Özel Yazılım Maliyet ve Süre Hesaplama Sihirbazı',
        subtitle:
          'Projenizin gereksinimlerini seçin, tahmini geliştirme süresi ve efor kırılımını anında görüntüleyin.',
        step1Title: '1. Platform ve Proje Türü',
        step2Title: '2. İhtiyaç Duyulan Özellikler & Modüller',
        step3Title: '3. Tasarım, Güvenlik ve Altyapı',
        summaryTitle: 'Proje Tahmin Özeti',
        estimatedTimeLabel: 'Tahmini Geliştirme Süresi',
        estimatedEffortLabel: 'Teknoloji & Efor Skoru',
        selectedFeaturesLabel: 'Seçilen Modüller',
        weeksUnit: 'Hafta',
        ctaButton: 'Bu Kapsam İçin Teklif Al',
        formTitle: 'Hesaplanan Projeniz İçin Teklif İsteyin',
        namePlaceholder: 'Adınız Soyadınız *',
        emailPlaceholder: 'E-posta Adresiniz *',
        phonePlaceholder: 'Telefon Numaranız',
        companyPlaceholder: 'Şirket Adınız',
        notesPlaceholder: 'Eklemek istediğiniz özel notlar...',
        submitBtn: 'Teklifi Hemen Gönder',
        successMsg: 'Proje talebiniz başarıyla alındı! Ekibimiz 24 saat içinde detaylı fizibilite ve teklifle size ulaşacaktır.',
      },
      techStack: {
        badge: 'Teknolojilerimiz',
        title: 'Modern, Güvenilir ve Geleceğe Hazır Teknoloji Yığını',
        subtitle: 'Projenizin ölçeğine en uygun modern dilleri, kütüphaneleri ve bulut altyapılarını kullanıyoruz.',
      },
      faq: {
        badge: 'Sıkça Sorulan Sorular',
        title: 'Özel Yazılım Hakkında Merak Edilenler',
        subtitle: 'Özel yazılım süreçlerimiz, fiyatlandırma ve telif hakları hakkında en çok sorulan sorular.',
        questions: [
          {
            question: 'Özel yazılım geliştirme maliyeti nasıl belirlenir?',
            answer:
              'Maliyet; projenin kapsayacağı platformlar (Web, iOS, Android), entegrasyon ihtiyaçları (ERP, Sanal POS, API), tasarım karmaşıklığı ve kullanıcı rol sayılarına göre gereken geliştirme eforu (adam/gün) üzerinden şeffaf bir şekilde hesaplanır.',
          },
          {
            question: 'Yazılımın kaynak kodları ve mülkiyeti kime ait olur?',
            answer:
              'Efes Tech olarak geliştirdiğimiz tüm özel yazılımların kaynak kodları, fikri mülkiyet hakları ve telifleri sözleşme ile eksiksiz olarak müşterimize devredilir. Herhangi bir sağlayıcı bağımlılığı (vendor lock-in) yaşamazsınız.',
          },
          {
            question: 'Proje tamamlandıktan sonra bakım ve destek veriyor musunuz?',
            answer:
              'Evet, canlıya alım sonrasında garanti süresi sunuyoruz. Ayrıca isteğe bağlı SLA (Hizmet Seviyesi Anlaşması) ile 7/24 sunucu izleme, güvenlik güncellemeleri, yedekleme ve yeni özellik geliştirme desteği sağlıyoruz.',
          },
          {
            question: 'Mevcut sistemlerimizle (muhasebe, ERP vb.) entegrasyon yapılabilir mi?',
            answer:
              'Kesinlikle. Mikro, Logo, SAP, Paraşüt, Nebim gibi ERP/muhasebe yazılımları, pazaryeri API\'leri ve özel donanımlarınız ile çift yönlü güvenli API entegrasyonları inşa ediyoruz.',
          },
          {
            question: 'Geliştirme sürecini nasıl takip edebilirim?',
            answer:
              'Çevik (Agile/Scrum) metodoloji kullanıyoruz. İki haftalık periyotlarla yapılan sprint demoları, paylaşılan test sunucuları (Staging) ve proje yönetim araçları ile her adımı şeffafça izleyebilirsiniz.',
          },
        ],
      },
      cta: {
        title: 'İşletmenizi Dijitalde Zirveye Taşıyacak Özel Yazılımınızı Birlikte Geliştirelim',
        subtitle: 'Projenizi analiz edelim, en doğru mimariyi ve şeffaf bütçe planını birlikte çıkaralım.',
        buttonText: 'Ücretsiz Keşif & Teklif Alın',
      },
    },
  },
  en: {
    nav: {
      home: 'Home',
      customSoftware: 'Custom Software',
      blog: 'Blog',
      projects: 'Projects',
      about: 'About',
      contact: 'Contact',
      faq: 'FAQ',
      quote: 'Get a Quote',
    },
    home: {
      meta: {
        title: 'Efes Tech - Custom Software & Mobile App Development',
        description:
          'Efes Tech delivers custom iOS, Android and web application development. Bespoke software engineering, AI integration, and successful projects like OTS, Elestir.net and Stuby.',
        keywords:
          'custom software, software development company, ios app development, android app development, web development, ai integration, software outsourcing, elestir.net, ots order tracking, stuby, dunya evim, pillclock',
      },
      hero: {
        highlight: 'For Your Business',
        title: 'Digital Transformation Solutions',
        subtitle:
          'We move your business into the future with modern technologies. We craft custom software solutions, mobile applications and web projects.',
        cta: 'Let\'s Bring Your Project to Life',
        ctaSecondary: 'Get a Quote',
      },
      stats: [
        { number: '50+', label: 'Completed Projects' },
        { number: '5+', label: 'Years of Experience' },
        { number: '100%', label: 'Client Satisfaction' },
      ],
      techBadges: ['iOS', 'Android', 'Web', 'Custom Software', 'UI/UX'],
      sections: {
        servicesTitle: 'Our Services',
        servicesSubtitle: 'We deliver the best solutions for your business',
        projectsTitle: 'Our Projects',
        projectsSubtitle: 'Highlights from the projects we have delivered',
        blogTitle: 'Blog',
        blogSubtitle: 'Fresh articles from the world of technology',
      },
      labels: {
        learnMore: 'Learn More',
        readMore: 'Read More',
      },
      services: [
        {
          title: 'iOS App Development',
          description:
            'We create native iOS applications powered by Swift and SwiftUI, and guide you throughout the App Store publishing process.',
          icon: 'pi pi-apple',
        },
        {
          title: 'Android App Development',
          description:
            'We develop modern Android applications with Kotlin and Jetpack Compose, including full Google Play Store deployment support.',
          icon: 'pi pi-android',
        },
        {
          title: 'Cross-Platform Development',
          description:
            'We build iOS and Android apps from a single codebase using React Native and Flutter. Fast and cost-effective solutions.',
          icon: 'pi pi-mobile',
        },
        {
          title: 'Web Application Development',
          description:
            'We deliver responsive, user-friendly web applications using modern technologies like Vue.js, React and Angular.',
          icon: 'pi pi-globe',
        },
        {
          title: 'Custom Software Development',
          description:
            'We build scalable, secure software tailored to your business needs, including backend systems and API integrations.',
          icon: 'pi pi-code',
        },
        {
          title: 'UI/UX Design',
          description:
            'We create modern, engaging interfaces with a user-first mindset, delivering prototypes and wireframes that delight users.',
          icon: 'pi pi-palette',
        },
      ],
    },
    projects: {
      meta: {
        title: 'Our Projects - Efes Tech',
        description: 'Mobile applications and web projects delivered by Efes Tech.',
      },
      title: 'Our Projects',
      subtitle: 'Projects we deliver using modern technologies',
      websiteLabel: 'Website',
    },
    projectDetail: {
      meta: {
        titleSuffix: ' | Efes Tech',
        descriptionFallback: 'Discover detailed information about our projects.',
      },
      technologiesTitle: 'Technologies Used',
      websiteLabel: 'Website',
      appStoreAlt: 'Download on the App Store',
      playStoreAlt: 'Get it on Google Play',
      privacyLabel: 'Privacy Policy',
      termsLabel: 'Terms of Use',
      notFoundTitle: 'Project Not Found',
      notFoundDescription: 'The project you are looking for could not be found or was removed.',
      backButton: 'Back to Projects',
    },
    blog: {
      meta: {
        title: 'Blog | Efes Tech - Custom Software, Enterprise Solutions & Tech',
        description:
          'Expert articles and guides on custom enterprise software, internal company tools, process automation, B2B portals, and modern tech architecture.',
        keywords: 'custom software, internal tools, b2b portal, corporate intranet, process automation, mobile apps, software agency, blog',
      },
      heroTitle: 'Blog & Enterprise Guides',
      heroSubtitle: 'Expert insights into custom software architecture, internal company workflows, and modern technology',
      readMore: 'Read More',
      searchPlaceholder: 'Search articles, topics or tags...',
      allCategory: 'All',
      resultsCount: 'articles found',
      noResultsTitle: 'No Articles Found',
      noResultsDesc: 'No blog posts matched your search query or selected category filter.',
      clearFilters: 'Clear Filters',
    },
    blogDetail: {
      titleSuffix: ' | Efes Tech Blog',
      backButton: 'Back to Blog',
      notFoundTitle: 'Post Not Found',
      notFoundDescription: 'The blog post you are looking for is not available.',
      backLinkLabel: 'Return to Blog',
      authorLabel: 'Efes Tech Engineering',
      shareLabel: 'Share',
      copyLinkLabel: 'Copy Link',
      copiedToast: 'Article link copied to clipboard!',
      relatedTitle: 'Related Articles',
      cta: {
        badge: 'Enterprise & Custom Solutions',
        title: 'Looking to Build Custom Software or Internal Tools for Your Company?',
        description:
          'Calculate estimated development timelines and get architectural consultation for custom enterprise software, B2B portals, and mobile solutions.',
        calcButton: 'Calculate Costs',
        quoteButton: 'Request a Quote',
      },
    },
    about: {
      meta: {
        title: 'About Us - Efes Tech',
        description:
          'We deliver modern software solutions with our experienced team at Efes Tech.',
      },
      heroTitle: 'About Us',
      heroSubtitle: 'We stand by you with our expert software development team',
      sections: {
        aboutUsTitle: 'Who Are We?',
        aboutUsContent:
          'At Efes Tech, we deliver the best service with our expert software development team. Our experienced developers and designers craft modern, user-friendly software solutions.',
        missionTitle: 'Our Mission',
        missionContent:
          'To understand the needs of our clients, create bespoke software solutions, and deliver the latest innovations by tracking technological trends closely.',
        visionTitle: 'Our Vision',
        visionContent:
          'To be a trusted technology partner in our clients’ digital transformation journeys by providing pioneering and innovative software solutions.',
        valuesTitle: 'Our Values',
        valuesList: [
          'Quality & Reliability',
          'Customer Centricity',
          'Innovation',
          'Transparency',
          'Continuous Improvement',
        ],
        contactTitle: 'Get in Touch',
        contactSubtitle: 'Reach out to us for your projects and get detailed information.',
        contactButton: 'Contact Us',
      },
    },
    contact: {
      meta: {
        title: 'Contact - Efes Tech',
        description: 'Contact Efes Tech and let’s discuss your project.',
      },
      title: 'Contact',
      subtitle: 'Get in touch and let’s talk about your project',
      infoCard: {
        title: 'Contact Information',
        addressLabel: 'Address',
        phoneLabel: 'Phone',
        emailLabel: 'E-mail',
        websiteLabel: 'Website',
        socialLinks: {
          linkedin: 'LinkedIn',
          instagram: 'Instagram',
          twitter: 'Twitter',
        },
      },
      form: {
        title: 'Contact Form',
        nameLabel: 'Full Name',
        emailLabel: 'Email Address',
        subjectLabel: 'Subject',
        messageLabel: 'Your Message',
        submitLabel: 'Send',
      },
      toasts: {
        validation: {
          summary: 'Error',
          detail: 'Please fill in all required fields.',
        },
        success: {
          summary: 'Success',
          detail: 'Your message has been sent. We will get back to you shortly.',
        },
        error: {
          summary: 'Error',
          detail: 'We could not send your message. Please try again later.',
        },
      },
    },
    footer: {
      companyName: 'Efes Tech',
      description: 'We stand by you with our expert software development team.',
      quickLinksTitle: 'Quick Links',
      quickLinks: [
        { to: '/en', label: 'Home' },
        { to: '/en/custom-software', label: 'Custom Software' },
        { to: '/en/projects', label: 'Projects' },
        { to: '/en/references', label: 'References' },
        { to: '/en/about', label: 'About' },
        { to: '/en/blog', label: 'Blog' },
        { to: '/en/faq', label: 'FAQ' },
        { to: '/en/contact', label: 'Contact' },
        { to: '/en/delete-account', label: 'Delete Account' },
        { to: '/en/privacy-policy', label: 'Privacy Policy' },
      ],
      contactTitle: 'Contact',
      contactItems: {
        email: 'admin@efestech.com',
        phone: '+90 536 788 44 50',
        address:
          'EVLİYA ÇELEBİ MAH. SADİ KONURALP CAD. IKSV VAKFI NO: 5 İÇ KAPI NO: 2 BEYOĞLU/İSTANBUL',
      },
      bottomText: '© {year} Efes Tech. All rights reserved.',
    },
    faq: {
      meta: {
        title: 'Frequently Asked Questions - Efes Tech',
        description:
          'Frequently asked questions about Efes Tech. Learn about our iOS, Android, and web application development services.',
      },
      heroTitle: 'Frequently Asked Questions',
      heroSubtitle: 'Get information about what you are curious about',
      questions: [
        {
          question: 'Which platforms do you develop applications for?',
          answer:
            'We provide application development services for iOS, Android, and Web platforms. We use Native iOS (Swift/SwiftUI), Native Android (Kotlin/Jetpack Compose), and modern web technologies (Vue.js, React, TypeScript).',
        },
        {
          question: 'How long does a project take?',
          answer:
            'Project duration varies depending on the scope and complexity of the project. Generally, we deliver a simple mobile app or MVP (Minimum Viable Product) in 4-6 weeks, while more comprehensive and complex projects take between 3-6 months.',
        },
        {
          question: 'How is pricing done?',
          answer:
            'Our projects are priced individually based on scope and requirements. You can fill out our contact form or contact us directly to get a detailed quote.',
        },
        {
          question: 'Do you provide support after application development?',
          answer:
            'Yes, we provide maintenance, update, and technical support services after application development. We provide continuous support to keep your application up-to-date and running smoothly.',
        },
        {
          question: 'What technologies do you use?',
          answer:
            'We use Swift and SwiftUI for iOS, Kotlin and Jetpack Compose for Android, and Vue.js, React, and TypeScript for Web. We also do cross-platform development with Flutter.',
        },
        {
          question: 'What projects are in your portfolio?',
          answer:
            'Our portfolio includes successful projects such as OTS (Order Tracking System), Eleştir, Stuby, İlaç Saati, Dünya Evim, Battleship.pro, and CSV Formatter & Mapper. You can get detailed information from our projects page.',
        },
      ],
    },
    ilacSaatiPrivacy: {
      meta: {
        title: 'Ilac Saati - Privacy Policy',
        description:
          'Privacy policy for Ilac Saati app covering data collection, usage, storage, user rights, and security.',
      },
      header: {
        eyebrow: 'Privacy Policy',
        title: 'Ilac Saati',
        updated: 'Last update: 15 November 2025',
      },
      sections: [
        {
          title: '1. General Information',
          paragraphs: [
            'Ilac Saati (“app”) is designed to help users manage medication reminders. By using the app, you accept the data processing activities described in this privacy policy.',
          ],
        },
        {
          title: '2. Data Collected',
          paragraphs: [
            'All data is stored on your device only; it is never sent to cloud services or third-party servers.',
          ],
          listItems: [
            '<strong>Personal Information:</strong> User profiles, contact names, medication names, and descriptions entered manually in the app.',
            '<strong>Device Data:</strong> Notification permissions, app version, device language.',
            '<strong>Log Records:</strong> Medication intake statuses, selected date ranges, reminder times.',
          ],
        },
        {
          title: '3. Purpose of Data Use',
          listItems: [
            'Scheduling and delivering medication reminders',
            'Managing multiple profiles on the same device',
            'Handling notification permissions and debugging',
          ],
        },
        {
          title: '4. Data Retention',
          paragraphs: [
            'All data is stored locally on your device. If you uninstall the app, all related data is removed.',
          ],
        },
        {
          title: '5. Third-Party Sharing',
          paragraphs: [
            'Your data is never shared, sold, or used for advertising with any third parties.',
          ],
        },
        {
          title: '6. User Rights',
          listItems: [
            'You can delete all data from within the app.',
            'You can manage notification permissions in your device settings.',
            'For questions: <a href="mailto:admin@efestech.com">admin@efestech.com</a>',
          ],
        },
        {
          title: '7. Security',
          paragraphs: [
            'Because data remains on local storage, you are responsible for protecting your device. Keeping your OS updated and using a secure lock screen is strongly recommended.',
          ],
        },
        {
          title: '8. Policy Changes',
          paragraphs: [
            'This privacy policy may change when necessary. Significant updates will be announced via in-app notifications or on our website.',
          ],
        },
      ] satisfies PolicySection[],
    },
    ilacSaatiTerms: {
      meta: {
        title: 'Ilac Saati - Terms of Use',
        description:
          'Terms of use for Ilac Saati app including service description, usage rules, liability disclaimer, and contact information.',
      },
      header: {
        eyebrow: 'Terms of Use',
        title: 'Ilac Saati',
        updated: 'Last update: 15 November 2025',
      },
      sections: [
        {
          title: '1. Acceptance of Terms',
          paragraphs: [
            'By using the Ilac Saati app, you agree to these terms of use. If you do not agree, please do not use the app.',
          ],
        },
        {
          title: '2. Service Description',
          paragraphs: [
            'The app helps individuals schedule medication times; it does not provide medical advice and is not a medical device. Always verify dosages with your physician or pharmacist.',
          ],
        },
        {
          title: '3. Usage Rules',
          listItems: [
            'The app is for personal use only.',
            'You may not misuse, reverse engineer, or share the app without authorization.',
            'Do not enter content that infringes on the rights of third parties.',
          ],
        },
        {
          title: '4. Notifications',
          paragraphs: [
            'Accurate reminders require notification and alarm permissions to be enabled on your device.',
            'Missing notifications may result from device settings or OS restrictions; responsibility lies with the user.',
          ],
        },
        {
          title: '5. Disclaimer of Liability',
          paragraphs: [
            'The app does not guarantee medication intake accuracy; the developer cannot be held responsible for damages arising from delayed or incorrect reminders.',
            'Do not rely on the app in medical emergencies; contact the appropriate healthcare providers.',
          ],
        },
        {
          title: '6. Pricing',
          paragraphs: [
            'The app is currently free. If paid features are introduced in the future, users will be informed.',
          ],
        },
        {
          title: '7. Termination',
          paragraphs: [
            'Users who violate these terms may have their access restricted. You may uninstall the app at any time to end use.',
          ],
        },
        {
          title: '8. Changes',
          paragraphs: [
            'These terms may be updated periodically. Changes will be communicated via the website or in-app notices. Users are responsible for staying informed of updates.',
          ],
        },
        {
          title: '9. Contact',
          paragraphs: [
            'For any questions, feedback, or complaints: <a href="mailto:admin@efestech.com">admin@efestech.com</a>',
          ],
        },
      ] satisfies PolicySection[],
    },
    quote: {
      meta: {
        title: 'Get a Quote - Efes Tech',
        description: 'Get a detailed quote for your project from Efes Tech.',
      },
      title: 'Get a Quote For Your Project',
      subtitle: 'Take the first step to bring your dream project to life',
      form: {
        nameLabel: 'Full Name *',
        emailLabel: 'Email Address *',
        phoneLabel: 'Phone Number',
        projectTypeLabel: 'Project Type *',
        budgetLabel: 'Estimated Budget (Optional)',
        detailsLabel: 'Project Details (Optional)',
        detailsPlaceholder: 'Briefly describe your project...',
        submitLabel: 'Request Quote',
        companyLabel: 'Company / Organization (Optional)',
        timelineLabel: 'Expected Timeline (Optional)',
        budgetPlaceholder: 'e.g., $5,000 or 50,000₺',
        projectStatusLabel: 'Project Status (Optional)',
        projectTypes: {
          mobile: 'Mobile App',
          web: 'Web App',
          custom: 'Custom Software',
          uiux: 'UI/UX Design',
          other: 'Other',
        },
        timelines: {
          t1: '1-3 Months',
          t2: '3-6 Months',
          t3: 'More than 6 months',
          t4: 'No rush',
        },
        projectStatuses: {
          idea: 'I just have an idea',
          design: 'In design phase',
          development: 'In development phase',
          revamp: 'Revamping an existing project',
        },
      },
      toasts: {
        validation: {
          summary: 'Error',
          detail: 'Please fill in the required fields.',
        },
        success: {
          summary: 'Success',
          detail: 'Your quote request has been received. We will get back to you shortly.',
        },
        error: {
          summary: 'Error',
          detail: 'Your quote request could not be sent. Please try again later.',
        },
      },
    },
    customSoftware: {
      meta: {
        title: 'Custom Software Development Services | Enterprise Solutions - Efes Tech',
        description:
          'Tailored web and mobile software development for your business. Zero license dependency, scalable cloud architectures, API integrations and agile engineering.',
        keywords:
          'custom software development, custom software company, enterprise software, custom web application, custom mobile app, b2b software solutions, software development istanbul',
      },
      hero: {
        badge: 'Enterprise & Scalable Solutions',
        title: 'Tailor-Made For Your Business',
        highlight: 'Software Engineering Solutions',
        subtitle:
          'We craft high-performance, secure, and license-free custom software designed from the ground up for business models that outgrow off-the-shelf software.',
        ctaPrimary: 'Calculate Cost',
        ctaSecondary: 'Request a Quote',
        stats: [
          { number: '50+', label: 'Delivered Projects' },
          { number: '100%', label: 'Code & IP Ownership' },
          { number: '5+', label: 'Years of Engineering' },
          { number: '24/7', label: 'Support & Maintenance' },
        ],
      },
      whyCustom: {
        badge: 'Why Custom Software?',
        title: 'Off-the-Shelf SaaS vs. Custom Software Development',
        subtitle:
          'Break free from the constraints of generic packages. Gain competitive advantage with bespoke solutions that scale seamlessly with your workflows.',
        comparisonHeaders: {
          feature: 'Criteria / Feature',
          custom: 'Efes Tech Custom Software',
          package: 'Off-the-Shelf Software (SaaS)',
        },
        comparisonRows: [
          {
            feature: 'Workflow Alignment',
            custom: '100% Tailored to your exact business processes',
            package: 'Forces your company to adapt to rigid templates',
            advantage: true,
          },
          {
            feature: 'Licensing & User Fees',
            custom: 'Zero per-user license fees (Unlimited users)',
            package: 'Ever-increasing monthly/annual subscription fees',
            advantage: true,
          },
          {
            feature: 'IP & Source Code Ownership',
            custom: 'Full intellectual property and code ownership is yours',
            package: 'Vendor lock-in, zero access to source code',
            advantage: true,
          },
          {
            feature: 'Scalability & Flexibility',
            custom: 'Add custom features and modules whenever needed',
            package: 'Restricted only to features the vendor provides',
            advantage: true,
          },
          {
            feature: 'Integrations & API Power',
            custom: 'Full integration with existing ERP, accounting and hardware',
            package: 'Limited or costly third-party integrations',
            advantage: true,
          },
          {
            feature: 'Data Security & Compliance',
            custom: 'Full control on your private cloud/servers (GDPR/KVKK)',
            package: 'Shared third-party infrastructure risks',
            advantage: true,
          },
        ],
      },
      services: {
        badge: 'Our Capabilities',
        title: 'Custom Software Development Areas',
        subtitle: 'From concept to production, modern and end-to-end software engineering across all platforms.',
        items: [
          {
            icon: 'pi pi-globe',
            title: 'Custom Web Apps & Portals',
            description:
              'Customer dashboards, B2B ordering platforms, operations management portals and scalable SaaS applications.',
            tags: ['Vue.js', 'React', 'TypeScript', 'Node.js'],
          },
          {
            icon: 'pi pi-mobile',
            title: 'Custom Mobile App Development',
            description:
              'Native (Swift, Kotlin) or cross-platform (Flutter) high-performance mobile apps for iOS and Android.',
            tags: ['iOS (Swift)', 'Android (Kotlin)', 'Flutter', 'Offline-First'],
          },
          {
            icon: 'pi pi-database',
            title: 'Custom ERP, CRM & Workflow Automation',
            description:
              'Centralized systems uniting your inventory, finance, logistics, and sales pipeline under one roof.',
            tags: ['Automation', 'Inventory & Ledger', 'Logistics', 'Analytics'],
          },
          {
            icon: 'pi pi-share-alt',
            title: 'API Development & System Integrations',
            description:
              'Bi-directional real-time integrations with marketplaces, e-invoicing, virtual POS payment gateways and logistics.',
            tags: ['REST / GraphQL', 'Virtual POS', 'E-Invoice', 'Marketplace API'],
          },
          {
            icon: 'pi pi-bolt',
            title: 'AI & Smart Assistant Integrations',
            description:
              'LLM/Gemini smart assistants trained on your company data, automated document processing, and predictive analytics.',
            tags: ['OpenAI / Gemini', 'LLM Integration', 'Automation', 'Data Analytics'],
          },
          {
            icon: 'pi pi-shield',
            title: 'High-Security Cloud Architectures & SLA',
            description:
              'High-availability, redundant, and secure infrastructure management on AWS, Google Cloud, and private servers.',
            tags: ['Docker', 'Cloud CI/CD', '24/7 Monitoring', 'SLA Support'],
          },
        ],
      },
      process: {
        badge: 'Our Methodology',
        title: 'Our 5-Step Custom Software Process',
        subtitle: 'Transparent communication, agile sprints, and regular demos for zero-risk delivery.',
        steps: [
          {
            step: '01',
            title: 'Discovery & Requirement Analysis',
            description:
              'We thoroughly analyze your workflows, business targets, and technical specifications to map out the project roadmap.',
          },
          {
            step: '02',
            title: 'Architecture & UI/UX Prototyping',
            description:
              'We craft modern, user-friendly Figma UI designs and architect a scalable database/system structure for your approval.',
          },
          {
            step: '03',
            title: 'Agile Development & Bi-Weekly Sprints',
            description:
              'We code in 2-week agile sprints, providing working feature demonstrations in a live staging environment at each sprint end.',
          },
          {
            step: '04',
            title: 'Testing, Security & Quality Assurance (QA)',
            description:
              'Comprehensive functional testing, load/performance benchmarks, and security audits to ensure flawless execution.',
          },
          {
            step: '05',
            title: 'Production Deployment, Code Handover & 24/7 Support',
            description:
              'We deploy to production, hand over all source code and documentation, and provide ongoing SLA maintenance.',
          },
        ],
      },
      calculator: {
        badge: 'Interactive Tool',
        title: 'Custom Software Cost & Timeline Wizard',
        subtitle:
          'Select your project requirements and instantly see estimated development duration and effort breakdown.',
        step1Title: '1. Platform & Project Type',
        step2Title: '2. Required Features & Modules',
        step3Title: '3. Design, Security & Infrastructure',
        summaryTitle: 'Project Estimate Summary',
        estimatedTimeLabel: 'Estimated Development Duration',
        estimatedEffortLabel: 'Tech & Effort Score',
        selectedFeaturesLabel: 'Selected Modules',
        weeksUnit: 'Weeks',
        ctaButton: 'Get Quote For This Scope',
        formTitle: 'Request a Quote for Calculated Scope',
        namePlaceholder: 'Full Name *',
        emailPlaceholder: 'Email Address *',
        phonePlaceholder: 'Phone Number',
        companyPlaceholder: 'Company Name',
        notesPlaceholder: 'Any additional notes or specifications...',
        submitBtn: 'Submit Quote Request',
        successMsg: 'Your quote request has been received! Our engineering team will review your scope and contact you within 24 hours.',
      },
      techStack: {
        badge: 'Tech Stack',
        title: 'Modern, Battle-Tested & Future-Proof Technologies',
        subtitle: 'We select the optimal programming languages, frameworks, and cloud services for your scale.',
      },
      faq: {
        badge: 'Frequently Asked Questions',
        title: 'Common Questions About Custom Software',
        subtitle: 'Everything you need to know about our custom software development process, costs, and IP rights.',
        questions: [
          {
            question: 'How is custom software development cost calculated?',
            answer:
              'Costs are transparently calculated based on engineering effort (man-days) required for platforms (Web, iOS, Android), integrations, design complexity, and security requirements.',
          },
          {
            question: 'Who owns the intellectual property and source code?',
            answer:
              'You do. Upon project completion, 100% of all intellectual property, copyright, and source code is transferred to your company with zero vendor lock-in.',
          },
          {
            question: 'Do you provide maintenance and SLA support after launch?',
            answer:
              'Yes. We provide an initial warranty period followed by flexible SLA maintenance packages including 24/7 monitoring, security updates, and new feature iterations.',
          },
          {
            question: 'Can you integrate with our existing ERP or accounting software?',
            answer:
              'Absolutely. We build robust bi-directional API integrations with ERPs, accounting systems (SAP, Logo, Mikro, etc.), CRM systems, and custom hardware.',
          },
          {
            question: 'How do I monitor the development progress?',
            answer:
              'We adhere to Agile/Scrum principles. You will have access to our staging servers, project management boards, and bi-weekly live sprint demos.',
          },
        ],
      },
      cta: {
        title: 'Let\'s Build Your Custom Software Solution Together',
        subtitle: 'Let\'s analyze your project requirements and determine the right architecture and transparent budget plan.',
        buttonText: 'Get Free Feasibility & Quote',
      },
    },
  },
} as const

type Translations = typeof translations

type LanguageCode = keyof Translations

type LanguageOption = {
  code: LanguageCode
  label: string
}

type PolicySection = {
  title: string
  paragraphs?: readonly string[]
  listItems?: readonly string[]
}

const languageOptions: readonly LanguageOption[] = [
  { code: 'tr', label: 'TR' },
  { code: 'en', label: 'EN' },
]

const isSupportedLanguage = (value: string): value is LanguageCode =>
  Object.prototype.hasOwnProperty.call(translations, value)

const getInitialLanguage = (): LanguageCode => {
  if (typeof window === 'undefined') {
    return 'tr'
  }

  // If URL path starts with /en, initialize as English; otherwise standard default is Turkish (tr)
  if (window.location.pathname === '/en' || window.location.pathname.startsWith('/en/')) {
    return 'en'
  }

  return 'tr'
}

export const useLanguageStore = defineStore('language', () => {
  const currentLanguage = ref<LanguageCode>(getInitialLanguage())

  const setLanguage = (language: LanguageCode) => {
    if (!isSupportedLanguage(language)) {
      return
    }

    currentLanguage.value = language

    if (typeof window !== 'undefined') {
      window.localStorage.setItem('preferredLanguage', language)
    }
  }

  const localizePath = (path: string): string => {
    const isEn = currentLanguage.value === 'en'
    // Normalize path by stripping /en prefix if present
    let cleanPath = path.replace(/^\/en(\/|$)/, '/').replace(/\/+$/, '')
    if (!cleanPath.startsWith('/')) {
      cleanPath = '/' + cleanPath
    }
    if (cleanPath === '') {
      cleanPath = '/'
    }

    if (!isEn) {
      if (cleanPath === '/custom-software' || cleanPath === '/custom-software-development') {
        return '/ozel-yazilim-gelistirme'
      }
      return cleanPath
    }

    // English routing
    if (cleanPath === '/') {
      return '/en'
    }
    if (cleanPath === '/ozel-yazilim-gelistirme' || cleanPath === '/custom-software-development') {
      return '/en/custom-software'
    }
    return `/en${cleanPath}`
  }

  const nav = computed(() => translations[currentLanguage.value].nav)
  const home = computed(() => translations[currentLanguage.value].home)
  const customSoftware = computed(() => translations[currentLanguage.value].customSoftware)
  const projects = computed(() => translations[currentLanguage.value].projects)
  const projectDetail = computed(() => translations[currentLanguage.value].projectDetail)
  const blog = computed(() => translations[currentLanguage.value].blog)
  const blogDetail = computed(() => translations[currentLanguage.value].blogDetail)
  const about = computed(() => translations[currentLanguage.value].about)
  const contact = computed(() => translations[currentLanguage.value].contact)
  const footer = computed(() => translations[currentLanguage.value].footer)
  const faq = computed(() => translations[currentLanguage.value].faq)
  const quote = computed(() => translations[currentLanguage.value].quote)
  const ilacSaatiPrivacy = computed(() => translations[currentLanguage.value].ilacSaatiPrivacy)
  const ilacSaatiTerms = computed(() => translations[currentLanguage.value].ilacSaatiTerms)

  watch(
    currentLanguage,
    (language) => {
      if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', language)
      }
    },
    { immediate: true },
  )

  return {
    currentLanguage,
    setLanguage,
    localizePath,
    languageOptions,
    nav,
    home,
    customSoftware,
    projects,
    projectDetail,
    blog,
    blogDetail,
    about,
    contact,
    footer,
    faq,
    quote,
    ilacSaatiPrivacy,
    ilacSaatiTerms,
  }
})
